export interface AppSettings {
  dir: 'ltr' | 'rtl';
  theme: string;
  sidenavOpened: boolean;
  sidenavCollapsed: boolean;
  boxed: boolean;
  horizontal: boolean;
  activeTheme: string;
  language: string;
  cardBorder: boolean;
  navPos: 'side' | 'top';
  modalpinned: boolean;
}

export const defaults: AppSettings = {
  dir: 'ltr',
  theme: 'light',
  sidenavOpened: true,
  sidenavCollapsed: false,
  boxed: false,
  horizontal: false,
  cardBorder: true,
  activeTheme: 'blue_theme',
  language: 'en',
  navPos: 'side',
  modalpinned: true
};
